import { Button, InfoBox, PriceInput, TransactionList } from '@sabavision/dio'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { ListTransactionRequest, withdrawRequest } from '../../api/financial'
import { ITransactionData } from '../../api/types'
import { Istate } from '../../reducers/types'
import Validate from '../../validations'
import withdrawValidator from '../../validations/schema/withdraw'
import { DataContainer, DepositContainer } from './styled'

function Withdraw() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const { userId } = useParams()

  // headless & user
  const headless = useSelector((state: Istate) => state.headless)
  const user = useSelector((state: Istate) => state.user)

  const [amount, setAmount] = React.useState<string | number>('')
  const [transactions, setTransactions] = React.useState<any[]>([])
  const [error, setErrors] = React.useState<Record<string, string | null>>({})

  React.useEffect(() => {
    handleListTransactionRequest()
  }, [])

  console.log(error)
  const validationData = () => {
    let valid = true
    const constrains = withdrawValidator(user.type)
    let err = {}
    const errorMessage = Validate({ amount }, 'amount', constrains)
    err = { ...err, amount: errorMessage }
    if (errorMessage) {
      valid = false
    }
    setErrors({ ...err })
    return valid
  }

  const handleRequest = () => {
    const data = {
      amount: Number(amount)
    }
    withdrawRequest(
      user.unique_id,
      data,
      () => {
        console.log()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  const handleSubmit = () => {
    const valid = validationData()
    if (valid) {
      handleRequest()
    }
  }

  const handleListTransactionRequest = () => {
    const requestData: ITransactionData = {
      // method: ['withdraw', 'decreased_by_admin', 'prepaid_decrease', 'decreased_wallet', 'decrease_from_old_panel'],
      method: ['withdraw'],
      page: 1,
      page_size: 10,
      section: 'advertiser'
    }

    ListTransactionRequest(
      userId,
      requestData,
      (res) => {
        let temp = []
        const result = res.data.data
        temp = result.map((item: any) => {
          return {
            unique_id: item.unique_id || Math.floor(Math.random() * 10e10),
            trace_number: item.trace_number || '-',
            amount: Number(item.amount) || 0,
            date: new Date(item.paid_at) || new Date(),
            status: item.status
          }
        })
        setTransactions(temp)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  return (
    <DataContainer>
      <div className="max-container">
        <DepositContainer>
          <PriceInput
            handleChange={(value) => {
              setAmount(value)
            }}
            label={t('withdraw_amount')}
            max={5000000}
            // error={error.amount}
          />

          <InfoBox
            message={t('withdraw_amount_condition', {
              amount: Intl.NumberFormat('fa-IR').format(
                Math.trunc(
                  headless.transaction?.withdraw?.attributes?.amount?.logics?.greaterThanOrEqualTo[user?.type] / 10
                )
              )
            })}
          />

          <Button
            data-test="button-withdraw"
            label={t('confirm')}
            fullWidth
            radius="10px"
            fontSize="12px"
            handleClick={() => {
              handleSubmit()
            }}
          />
        </DepositContainer>
      </div>

      <span className="divider">
        <span>{t('withdraw_amount_history')}</span>
      </span>

      <div style={{ width: '100%' }}>
        {!!transactions.length && (
          <TransactionList
            data={transactions}
            handleScrollToBottom={() => {
              console.log()
            }}
          />
        )}
      </div>
    </DataContainer>
  )
}

export default Withdraw
